// extracted by mini-css-extract-plugin
module.exports = {"listText":"ShowMoreList_listText__tfJiv","showMore":"ShowMoreList_showMore__Ll7Ig"};